export default __webpack_public_path__ + "static/media/Preview_mobile_unsel.233fd4b1.svg";